// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-step {
	background: var(--survey-card-background-color);
	border-radius: 5px;
	text-align: center;
	font-size: 16px;
	position: relative;
	font-family: Helvetica, Arial, sans-serif;
	width: 414px;
	min-height: 100%;
}

.survey-step em {
	font-style: italic;
}

.survey-step strong,
.survey-step strong em {
	font-weight: bold;
}

.survey-step span,
.survey-step div,
.survey-step button,
.survey-step a {
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-o-user-select: none;
	user-select: none;
}

.survey-step.system-step {
	width: auto;
	min-height: auto;
}

.survey-step a {
	text-decoration: none;
}

.survey-step .status-bar-background {
	position: sticky;
	position: -webkit-sticky;
	left: 0;
	top: 0;
	right: 0;
	height: env(safe-area-inset-top);
	width: 100%;
	z-index: 1;
	background: inherit;
}

.survey-step .step-title {
	font-size: 29px;
}

.survey-step .step-text {
	font-size: 16px;
}

.survey-step .step-text.learn-more {
	font-size: 14px;
}

.survey-step .step-content {
	padding-top: 10px;
	padding-bottom: 20px;
	padding-left: 20px;
	padding-right: 20px;
}

.survey-step .current-step {
	opacity: 0;
}

.survey-step.system-step .current-step {
	opacity: 1;
}

.survey-step.visible .current-step,
.survey-step.visible .footer,
.survey-step.visible .step-footnote {
	animation: fadeInAnimation ease 0.5s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
}

.template-slider .survey-step.visible .current-step,
.template-slider .survey-step.visible .footer,
.template-slider .survey-step.visible .step-footnote {
	animation: none;
}

.template-slider .survey-step .current-step,
.template-slider .survey-step .footer,
.template-slider .survey-step .step-footnote {
	opacity: 1;
}

.survey-step .step-content .step-title {
	margin-bottom: 15px;
	line-height: 1.2em;
}

.survey-step .step-content .step-text {
	margin-bottom: 15px;
	line-height: 1.3;
}

.survey-step .step-content .step-image-main img {
	width: 100%;
	padding: 0;
	margin: 0;
	padding-bottom: 40px;
}

.survey-step .step-content .step-image-icon {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-bottom: 15px;
}

.survey-step .step-content .step-image-icon.left {
	justify-content: start;
}

.survey-step .step-content .step-image-icon.right {
	justify-content: end;
}

.survey-step .step-content .step-image-icon img {
	max-width: 100%;
	max-height: 60px;
	padding: 0;
	margin: 0;
}

.survey-step .footer .step-footnote {
	opacity: 1;
	animation: none;
}

.survey-step .step-footnote {
	text-align: center;
	color: var(--survey-text-color-muted);
	padding: 0px 15px 25px 15px;
	font-weight: lighter;
	font-size: 14px;
	opacity: 0;
}

.survey-step .consent-review .step-content {
	padding-top: 0;
	padding-bottom: 15px;
}

.survey-step  .visual-consent-step .step-text {
	white-space: pre-wrap;
}

.survey-step .instruction-step .browser-check-failure {
	padding-top: 20px;
	padding-bottom: 20px;
	background-color: var(--survey-error-background-color);
	border: solid 1px var(--survey-error-border-color);
	border-radius: 5px;
	box-shadow: 0px 0px 3px var(--survey-panel-shadow-color);
}

.survey-step .instruction-step .browser-check-failure .fa {
	color: var(--survey-error-icon-color);
}

.survey-step .footer {
	bottom: 0;
	position: -webkit-sticky;
	position: sticky;
	background-color: var(--survey-card-background-color);
	padding-bottom: 20px;
	z-index: 2;
	padding-left: 20px;
	padding-right: 20px;
	border-radius: 0px 0px 5px 5px;
	margin-top: 3px;
	opacity: 0;
}

.survey-step .footer.shadowed {
	box-shadow: 0px -2px 2px var(--survey-soft-shadow-color);
}

.survey-step .continue-button {
	display: inline-block;
	margin-top: 17px;
	font-size: 16px;
	padding: 16px;
	background: var(--default-primary-color, #5381c3);
	font-size: 17px;
	color: #FFF;
	font-weight: bold;
	border: solid 1px var(--default-primary-color, #5381c3);
	border-radius: 5px;
	cursor: pointer;
	width: 100%;
	box-sizing: border-box;
	border-radius: 6px;
	line-height: 17px;
}

.survey-step .continue-button:disabled {
	background: var(--survey-card-background-color) !important;
	color: var(--survey-text-color-3) !important;
	border-color: var(--survey-disabled-border-color) !important;
	cursor: default;
}

.survey-step.card-based .continue-button:disabled {
	border: none !important;
	background: var(--survey-border-color-strong) !important;
	color: var(--survey-text-color-3) !important;
}

.survey-step .skip-wrapper {
	width: 100%;
}

.survey-step .skip-wrapper .skip-button {
	color: var(--survey-accent-color);
	cursor: pointer;
	padding: 10px;
	display: inline-block;
	font-size: 14px;
	margin-top: 10px;
}

.survey-step .footer .scroll-marker-wrapper {
	position: absolute;
	left: calc(50% - 15px);
	width: 30px;
	border-radius: 15px;
	height: 30px;
	color: var(--survey-border-color-strong);
	top: -15px;
	background: var(--survey-card-background-color);
	box-shadow: 0px -2px 2px var(--survey-soft-shadow-color);
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.survey-step .footer.has-footnote {
	padding-bottom: 0;
}

.survey-step .footer.has-footnote .step-footnote {
	margin-top: 20px;
}

.survey-step .step-image {
	width: 340px;
	max-width: 100%;
	margin-bottom: 15px;
}

.survey-step .learn-more-frame {
	height: 500px;
	overflow-y: scroll;
	text-align: left;
	width: 100%;
	box-sizing: border-box;
	border: none;
}

.survey-step .review-frame-wrapper {
	overflow: hidden;
	height: 400px;
	position: relative;
	/* Signed consent renders as light "paper" in both schemes, intentionally. */
	background: #FFF;
}

.survey-step .review-frame {
	text-align: left;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: none;
	-webkit-overflow-scrolling: touch;
}
.survey-step .review-frame-wrapper .consent-markdown-container {
	padding-top: 10px;
	max-height: 100%;
	overflow-y: auto;
}

.survey-step .toolbar {
	bottom: 0;
	position: -webkit-sticky;
	position: sticky;
	height: 20px;
	padding-top: 15px;
	padding-bottom: 15px;
	background: var(--survey-card-background-color);
}

.survey-step .toolbar.single-button {
	height: auto;
	padding-left: 15px;
	padding-right: 15px;
	padding-top: 0px;
}

.survey-step .toolbar .button {
	color: var(--survey-accent-color);
	cursor: pointer;
	position: absolute;
	top: 15px;
}

.survey-step .toolbar .button.disabled {
	color: var(--survey-text-color-3) !important;
	cursor: auto;
	pointer-events: none;
}

.survey-step .toolbar .left-button {
	left: 20px;
}

.survey-step .toolbar .right-button {
	right: 20px;
}

.survey-step .signature-line {
	margin-left: 30px;
	margin-right: 30px;
	border-bottom: solid 1px var(--survey-border-color-strong);
	color: var(--survey-text-color-5);
	font-size: 14px;
	text-align: left;
	line-height: 20px;
	margin-top: 40px;
	margin-bottom: 40px;
}

.survey-step .clear-signature-button {
	cursor: pointer;
	color: var(--survey-accent-color);
	font-size: 12px;
}

.survey-step .validation-errors .fa {
	color: var(--survey-error-icon-color);
}

.survey-step .validation-errors .validation-error {
	font-size: 12px;
	padding-top: 10px;
	padding-bottom: 10px;
}

.survey-step .completion-indicator {
	padding-bottom: 40px;
}

.survey-step .web-view-step {
	border-radius: 0px 0px 5px 5px;
	overflow: hidden;
}

.survey-step .web-view-step iframe {
	overflow-y: auto;
	overflow-x: hidden;
	height: 550px;
	pointer-events: auto;
	-webkit-overflow-scrolling: touch;
}

@media (hover: hover) {
	.survey-step .continue-button:hover {
		background: var(--survey-accent-fill-color);
		color: var(--survey-on-accent-color);
		cursor: pointer;
	}
}

@media (max-width: 576px) {
	.survey-step {
		border-radius: 0;
		margin-bottom: 0;
	}

	.survey-step .footer {
		position: relative;
		border-radius: 0;
	}

	.survey-step .footer.shadowed {
		box-shadow: none;
	}

	.survey-step .web-view-step {
		border-radius: 0;
	}

	.survey-step .footer .scroll-marker-wrapper {
		display: none !important;
	}
}

.survey-step ol {
	list-style-type: decimal;
	white-space: normal;
	list-style-position: inside;
}

.survey-step ul {
	list-style-type: disc;
	text-align: left;
	display: block;
	margin-inline-start: 0px;
	margin-inline-end: 0px;
	padding-inline-start: 40px;
	white-space: normal;
}

.survey-step ul ul {
	list-style-type: circle;
}

.survey-step ul ul ul {
	list-style-type: square;
}

@keyframes fadeInAnimation {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

.survey-step .visual-consent-learn-more {
	margin-top: -58px;
	position: relative;
	z-index: 5;
}

.survey-step .visual-consent-learn-more .header {
	text-align: center;
	position: relative;
	height: 58px;
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	top: env(safe-area-inset-top, 0);
	background-color: var(--survey-card-background-color);
	z-index: 2;
	border-radius: 5px 5px 0px 0px;
}

.survey-step .visual-consent-learn-more .header .step-counter {
	font-weight: bold;
	text-align: center;
	padding: 20px;
}

.survey-step .visual-consent-learn-more .header .cancel-button {
	position: absolute;
	right: 20px;
	top: 20px;
	color: var(--survey-accent-color);
	cursor: pointer;
}

.survey-step.survey-step-v2 .step-content .step-text {
	margin-bottom: 15px;
}

.survey-step.survey-step-v2 .step-content .step-text.learn-more {
	margin-top: 15px;
}

.survey-step.survey-step-v2 .step-content {
	padding-bottom: 1px;
}

.survey-step.survey-step-v2 .instruction-step .step-content,
.survey-step.survey-step-v2 .capture-step .step-content {
	padding-bottom: 20px;
}

fieldset.step-content {
    border: 0;
    margin-inline: 0;
    padding-block: 0;
    padding-inline: 0;
    min-width: 0;
}
fieldset.step-content legend {
    width: 100%;
    padding: 0;
    display: contents;
}

.wait-step .loading-indicator {
	height: 44px;
	padding: 10px 0 0 !important;
	font-size: 60px;
}

.countdown-step .countdown-indicator
{
	padding-bottom: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/SurveyStep.css"],"names":[],"mappings":"AAAA;CACC,+CAA+C;CAC/C,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,yCAAyC;CACzC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;;;CAIC,yBAAyB;CACzB,wBAAwB;CACxB,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,OAAO;CACP,MAAM;CACN,QAAQ;CACR,gCAAgC;CAChC,WAAW;CACX,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,oCAAoC;CACpC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;;;CAGC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,SAAS;CACT,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,qCAAqC;CACrC,2BAA2B;CAC3B,oBAAoB;CACpB,eAAe;CACf,UAAU;AACX;;AAEA;CACC,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,sDAAsD;CACtD,kDAAkD;CAClD,kBAAkB;CAClB,wDAAwD;AACzD;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,SAAS;CACT,wBAAwB;CACxB,gBAAgB;CAChB,qDAAqD;CACrD,oBAAoB;CACpB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,UAAU;AACX;;AAEA;CACC,wDAAwD;AACzD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,iDAAiD;CACjD,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,uDAAuD;CACvD,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,0DAA0D;CAC1D,4CAA4C;CAC5C,4DAA4D;CAC5D,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,wDAAwD;CACxD,4CAA4C;AAC7C;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,aAAa;CACb,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,wCAAwC;CACxC,UAAU;CACV,+CAA+C;CAC/C,wDAAwD;CACxD,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,4EAA4E;CAC5E,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,iCAAiC;AAClC;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,wBAAwB;CACxB,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,+CAA+C;AAChD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,4CAA4C;CAC5C,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,0DAA0D;CAC1D,iCAAiC;CACjC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,oBAAoB;CACpB,iCAAiC;AAClC;;AAEA;CACC;EACC,2CAA2C;EAC3C,oCAAoC;EACpC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,wBAAwB;CACxB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,cAAc;CACd,wBAAwB;CACxB,sBAAsB;CACtB,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,wBAAwB;CACxB,gBAAgB;CAChB,MAAM;CACN,gCAAgC;CAChC,qDAAqD;CACrD,UAAU;CACV,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;;CAEC,oBAAoB;AACrB","sourcesContent":[".survey-step {\n\tbackground: var(--survey-card-background-color);\n\tborder-radius: 5px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tposition: relative;\n\tfont-family: Helvetica, Arial, sans-serif;\n\twidth: 414px;\n\tmin-height: 100%;\n}\n\n.survey-step em {\n\tfont-style: italic;\n}\n\n.survey-step strong,\n.survey-step strong em {\n\tfont-weight: bold;\n}\n\n.survey-step span,\n.survey-step div,\n.survey-step button,\n.survey-step a {\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n\n.survey-step.system-step {\n\twidth: auto;\n\tmin-height: auto;\n}\n\n.survey-step a {\n\ttext-decoration: none;\n}\n\n.survey-step .status-bar-background {\n\tposition: sticky;\n\tposition: -webkit-sticky;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\theight: env(safe-area-inset-top);\n\twidth: 100%;\n\tz-index: 1;\n\tbackground: inherit;\n}\n\n.survey-step .step-title {\n\tfont-size: 29px;\n}\n\n.survey-step .step-text {\n\tfont-size: 16px;\n}\n\n.survey-step .step-text.learn-more {\n\tfont-size: 14px;\n}\n\n.survey-step .step-content {\n\tpadding-top: 10px;\n\tpadding-bottom: 20px;\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.survey-step .current-step {\n\topacity: 0;\n}\n\n.survey-step.system-step .current-step {\n\topacity: 1;\n}\n\n.survey-step.visible .current-step,\n.survey-step.visible .footer,\n.survey-step.visible .step-footnote {\n\tanimation: fadeInAnimation ease 0.5s;\n\tanimation-iteration-count: 1;\n\tanimation-fill-mode: forwards;\n}\n\n.template-slider .survey-step.visible .current-step,\n.template-slider .survey-step.visible .footer,\n.template-slider .survey-step.visible .step-footnote {\n\tanimation: none;\n}\n\n.template-slider .survey-step .current-step,\n.template-slider .survey-step .footer,\n.template-slider .survey-step .step-footnote {\n\topacity: 1;\n}\n\n.survey-step .step-content .step-title {\n\tmargin-bottom: 15px;\n\tline-height: 1.2em;\n}\n\n.survey-step .step-content .step-text {\n\tmargin-bottom: 15px;\n\tline-height: 1.3;\n}\n\n.survey-step .step-content .step-image-main img {\n\twidth: 100%;\n\tpadding: 0;\n\tmargin: 0;\n\tpadding-bottom: 40px;\n}\n\n.survey-step .step-content .step-image-icon {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\tmargin-bottom: 15px;\n}\n\n.survey-step .step-content .step-image-icon.left {\n\tjustify-content: start;\n}\n\n.survey-step .step-content .step-image-icon.right {\n\tjustify-content: end;\n}\n\n.survey-step .step-content .step-image-icon img {\n\tmax-width: 100%;\n\tmax-height: 60px;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.survey-step .footer .step-footnote {\n\topacity: 1;\n\tanimation: none;\n}\n\n.survey-step .step-footnote {\n\ttext-align: center;\n\tcolor: var(--survey-text-color-muted);\n\tpadding: 0px 15px 25px 15px;\n\tfont-weight: lighter;\n\tfont-size: 14px;\n\topacity: 0;\n}\n\n.survey-step .consent-review .step-content {\n\tpadding-top: 0;\n\tpadding-bottom: 15px;\n}\n\n.survey-step  .visual-consent-step .step-text {\n\twhite-space: pre-wrap;\n}\n\n.survey-step .instruction-step .browser-check-failure {\n\tpadding-top: 20px;\n\tpadding-bottom: 20px;\n\tbackground-color: var(--survey-error-background-color);\n\tborder: solid 1px var(--survey-error-border-color);\n\tborder-radius: 5px;\n\tbox-shadow: 0px 0px 3px var(--survey-panel-shadow-color);\n}\n\n.survey-step .instruction-step .browser-check-failure .fa {\n\tcolor: var(--survey-error-icon-color);\n}\n\n.survey-step .footer {\n\tbottom: 0;\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\tbackground-color: var(--survey-card-background-color);\n\tpadding-bottom: 20px;\n\tz-index: 2;\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\tborder-radius: 0px 0px 5px 5px;\n\tmargin-top: 3px;\n\topacity: 0;\n}\n\n.survey-step .footer.shadowed {\n\tbox-shadow: 0px -2px 2px var(--survey-soft-shadow-color);\n}\n\n.survey-step .continue-button {\n\tdisplay: inline-block;\n\tmargin-top: 17px;\n\tfont-size: 16px;\n\tpadding: 16px;\n\tbackground: var(--default-primary-color, #5381c3);\n\tfont-size: 17px;\n\tcolor: #FFF;\n\tfont-weight: bold;\n\tborder: solid 1px var(--default-primary-color, #5381c3);\n\tborder-radius: 5px;\n\tcursor: pointer;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tborder-radius: 6px;\n\tline-height: 17px;\n}\n\n.survey-step .continue-button:disabled {\n\tbackground: var(--survey-card-background-color) !important;\n\tcolor: var(--survey-text-color-3) !important;\n\tborder-color: var(--survey-disabled-border-color) !important;\n\tcursor: default;\n}\n\n.survey-step.card-based .continue-button:disabled {\n\tborder: none !important;\n\tbackground: var(--survey-border-color-strong) !important;\n\tcolor: var(--survey-text-color-3) !important;\n}\n\n.survey-step .skip-wrapper {\n\twidth: 100%;\n}\n\n.survey-step .skip-wrapper .skip-button {\n\tcolor: var(--survey-accent-color);\n\tcursor: pointer;\n\tpadding: 10px;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tmargin-top: 10px;\n}\n\n.survey-step .footer .scroll-marker-wrapper {\n\tposition: absolute;\n\tleft: calc(50% - 15px);\n\twidth: 30px;\n\tborder-radius: 15px;\n\theight: 30px;\n\tcolor: var(--survey-border-color-strong);\n\ttop: -15px;\n\tbackground: var(--survey-card-background-color);\n\tbox-shadow: 0px -2px 2px var(--survey-soft-shadow-color);\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.survey-step .footer.has-footnote {\n\tpadding-bottom: 0;\n}\n\n.survey-step .footer.has-footnote .step-footnote {\n\tmargin-top: 20px;\n}\n\n.survey-step .step-image {\n\twidth: 340px;\n\tmax-width: 100%;\n\tmargin-bottom: 15px;\n}\n\n.survey-step .learn-more-frame {\n\theight: 500px;\n\toverflow-y: scroll;\n\ttext-align: left;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tborder: none;\n}\n\n.survey-step .review-frame-wrapper {\n\toverflow: hidden;\n\theight: 400px;\n\tposition: relative;\n\t/* Signed consent renders as light \"paper\" in both schemes, intentionally. */\n\tbackground: #FFF;\n}\n\n.survey-step .review-frame {\n\ttext-align: left;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: border-box;\n\tborder: none;\n\t-webkit-overflow-scrolling: touch;\n}\n.survey-step .review-frame-wrapper .consent-markdown-container {\n\tpadding-top: 10px;\n\tmax-height: 100%;\n\toverflow-y: auto;\n}\n\n.survey-step .toolbar {\n\tbottom: 0;\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\theight: 20px;\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n\tbackground: var(--survey-card-background-color);\n}\n\n.survey-step .toolbar.single-button {\n\theight: auto;\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n\tpadding-top: 0px;\n}\n\n.survey-step .toolbar .button {\n\tcolor: var(--survey-accent-color);\n\tcursor: pointer;\n\tposition: absolute;\n\ttop: 15px;\n}\n\n.survey-step .toolbar .button.disabled {\n\tcolor: var(--survey-text-color-3) !important;\n\tcursor: auto;\n\tpointer-events: none;\n}\n\n.survey-step .toolbar .left-button {\n\tleft: 20px;\n}\n\n.survey-step .toolbar .right-button {\n\tright: 20px;\n}\n\n.survey-step .signature-line {\n\tmargin-left: 30px;\n\tmargin-right: 30px;\n\tborder-bottom: solid 1px var(--survey-border-color-strong);\n\tcolor: var(--survey-text-color-5);\n\tfont-size: 14px;\n\ttext-align: left;\n\tline-height: 20px;\n\tmargin-top: 40px;\n\tmargin-bottom: 40px;\n}\n\n.survey-step .clear-signature-button {\n\tcursor: pointer;\n\tcolor: var(--survey-accent-color);\n\tfont-size: 12px;\n}\n\n.survey-step .validation-errors .fa {\n\tcolor: var(--survey-error-icon-color);\n}\n\n.survey-step .validation-errors .validation-error {\n\tfont-size: 12px;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n}\n\n.survey-step .completion-indicator {\n\tpadding-bottom: 40px;\n}\n\n.survey-step .web-view-step {\n\tborder-radius: 0px 0px 5px 5px;\n\toverflow: hidden;\n}\n\n.survey-step .web-view-step iframe {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\theight: 550px;\n\tpointer-events: auto;\n\t-webkit-overflow-scrolling: touch;\n}\n\n@media (hover: hover) {\n\t.survey-step .continue-button:hover {\n\t\tbackground: var(--survey-accent-fill-color);\n\t\tcolor: var(--survey-on-accent-color);\n\t\tcursor: pointer;\n\t}\n}\n\n@media (max-width: 576px) {\n\t.survey-step {\n\t\tborder-radius: 0;\n\t\tmargin-bottom: 0;\n\t}\n\n\t.survey-step .footer {\n\t\tposition: relative;\n\t\tborder-radius: 0;\n\t}\n\n\t.survey-step .footer.shadowed {\n\t\tbox-shadow: none;\n\t}\n\n\t.survey-step .web-view-step {\n\t\tborder-radius: 0;\n\t}\n\n\t.survey-step .footer .scroll-marker-wrapper {\n\t\tdisplay: none !important;\n\t}\n}\n\n.survey-step ol {\n\tlist-style-type: decimal;\n\twhite-space: normal;\n\tlist-style-position: inside;\n}\n\n.survey-step ul {\n\tlist-style-type: disc;\n\ttext-align: left;\n\tdisplay: block;\n\tmargin-inline-start: 0px;\n\tmargin-inline-end: 0px;\n\tpadding-inline-start: 40px;\n\twhite-space: normal;\n}\n\n.survey-step ul ul {\n\tlist-style-type: circle;\n}\n\n.survey-step ul ul ul {\n\tlist-style-type: square;\n}\n\n@keyframes fadeInAnimation {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n.survey-step .visual-consent-learn-more {\n\tmargin-top: -58px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.survey-step .visual-consent-learn-more .header {\n\ttext-align: center;\n\tposition: relative;\n\theight: 58px;\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\ttop: 0;\n\ttop: env(safe-area-inset-top, 0);\n\tbackground-color: var(--survey-card-background-color);\n\tz-index: 2;\n\tborder-radius: 5px 5px 0px 0px;\n}\n\n.survey-step .visual-consent-learn-more .header .step-counter {\n\tfont-weight: bold;\n\ttext-align: center;\n\tpadding: 20px;\n}\n\n.survey-step .visual-consent-learn-more .header .cancel-button {\n\tposition: absolute;\n\tright: 20px;\n\ttop: 20px;\n\tcolor: var(--survey-accent-color);\n\tcursor: pointer;\n}\n\n.survey-step.survey-step-v2 .step-content .step-text {\n\tmargin-bottom: 15px;\n}\n\n.survey-step.survey-step-v2 .step-content .step-text.learn-more {\n\tmargin-top: 15px;\n}\n\n.survey-step.survey-step-v2 .step-content {\n\tpadding-bottom: 1px;\n}\n\n.survey-step.survey-step-v2 .instruction-step .step-content,\n.survey-step.survey-step-v2 .capture-step .step-content {\n\tpadding-bottom: 20px;\n}\n\nfieldset.step-content {\n    border: 0;\n    margin-inline: 0;\n    padding-block: 0;\n    padding-inline: 0;\n    min-width: 0;\n}\nfieldset.step-content legend {\n    width: 100%;\n    padding: 0;\n    display: contents;\n}\n\n.wait-step .loading-indicator {\n\theight: 44px;\n\tpadding: 10px 0 0 !important;\n\tfont-size: 60px;\n}\n\n.countdown-step .countdown-indicator\n{\n\tpadding-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
